export const decodeFromMetaTag = (name: string): string | null => {
  const metaTag = document.querySelector(`meta[name="${name}"]`);

  if (!metaTag) {
    return null;
  }

  return decodeURIComponent(atob(metaTag.getAttribute("content") || ""));
};
